import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { StatementService } from '../../../service/StatementService'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import fetchIgnores from './fetch-ignores'
import { IStatement } from '../../../model/statement'

export default async function unignoreStatement(context: BareActionContext<StatementState, RootState>, statement: IStatement)
{
    statementUtils.statementService.unignore(statement).then((result: any) => {
        fetchIgnores(context, statement)
    })

    return
}